import { render, staticRenderFns } from "./EditHospital.vue?vue&type=template&id=49bf4c69&scoped=true&"
import script from "./EditHospital.vue?vue&type=script&lang=js&"
export * from "./EditHospital.vue?vue&type=script&lang=js&"
import style0 from "./EditHospital.vue?vue&type=style&index=0&id=49bf4c69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bf4c69",
  null
  
)

export default component.exports